import React from 'react';
import bemHelper from 'react-bem-helper';

import analyticsPolicies from '../../analytics/policies';
import AdditionalText from '../AdditionalTextModule/AdditionalTextModule';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'returns' });

class ReturnsModule extends React.Component {

  render() {
    const { address, link } = this.props;
    const defaultReturnsLink = 'https://info.notonthehighstreet.com/hc/en-us/articles/206411168-What-is-your-returns-policy-';

    return (
      <div {...bem('container')}>
        <div {...bem()}>
          <h2 {...bem('title')}>
            Returns
          </h2>

          <div {...bem('address-container')}>
            <AdditionalText link={link} defaultLink={defaultReturnsLink} text="returns policy"
                            onClickFunction={analyticsPolicies.registryReturns}
                            classNames={{ alone: true }}/>
            {
              address &&
              <div {...bem('address')}>
                <h3 {...bem('address-title')}>Returns Address</h3>
                <p {...bem('address-text')}>{address}</p>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

}

export default ReturnsModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/ReturnsModule/ReturnsModule.js